window.addEventListener('DOMContentLoaded', function() {
  const btnShowPass = document.querySelectorAll('.buttonShowPassword')
  if (btnShowPass) {
    btnShowPass.forEach(el => {
      const inputPass = el.previousElementSibling
      if (inputPass) {
        el.addEventListener('click', () => {
          if (inputPass.type === 'text') {
            inputPass.type = 'password'
            el.classList.add('iconVisibilityOn')
            el.classList.remove('iconVisibilityOff')
          } else {
            inputPass.type = 'text'
            el.classList.remove('iconVisibilityOn')
            el.classList.add('iconVisibilityOff')
          }
        })
      }
    })
  }
})
